export const marketplace = {
  marketplaceSearchInputPlaceholderTitle: 'Search',
  marketplaceDetailsCurtainCopyOptionTitle: 'Copy link',
  marketplaceDetailsCurtainFlagOptionTitle: 'Flag content',
  marketplaceDetailsCurtainCopiedAlertText: 'Link copied!',
  marketplaceDetailsFlagCurtainTitle: 'Flag',
  marketplaceReportedCurtainContent: 'Content reported',
  marketplaceAllItems: 'All items',
  marketplaceWantToBuy: 'Want to buy {item} from {appname}'
}
